import Image from "next/image";

import { EndpointService } from "@/services/business/endpoint.service";

//

const endpoints = new EndpointService({
  main: {
    path: "/",
    title: "Главная",
  },
  onboarding: {
    path: "/onboarding",
    title: "Первоначальная настройка",
  },
  signIn: {
    path: "/sign-in",
    title: "Вход",
  },
  signUp: {
    path: "/sign-up",
    title: "Регистрация",
  },
  notAllowed: {
    path: "/403",
    title: "Не достаточно прав",
  },
  dashboard: {
    path: "/dashboard",
    title: "Главная",
    icon: "House",
    sub: {
      cabinets: {
        path: "/cabinets",
        title: "Магазины Kaspi",
        icon: "KeySquare",
      },
      orders: {
        path: "/orders",
        title: "Заказы",
        icon: "ShoppingCart",
      },
      products: {
        path: "/products",
        title: "Товары",
        icon: "Package",
        sub: {
          create: {
            path: "/create",
            title: "Новый товар",
            activeItemKey: "dashboard.products",
          },
          id: {
            path: "/[id]",
            title: "Текущий товар",
            activeItemKey: "dashboard.products",
          },
          enters: {
            path: "/enters",
            title: "Приемки",
            icon: "SquarePlus",
          },
          losses: {
            path: "/losses",
            title: "Списания",
            icon: "SquareMinus",
          },
        },
      },
      offers: {
        path: "/offers",
        title: "Мои карточки",
        icon: "GalleryHorizontalEnd",
      },
      kaspiOffers: {
        path: "/kaspi-products",
        title: "Аналитика Kaspi",
        icon: "ChartColumn",
      },
      billing: {
        path: "/billing",
        title: "Подписка",
        icon: "CreditCard",
      },
      referral: {
        path: "/referral",
        title: "Реферальная программа",
        icon: "Gem",
      },
      settings: {
        path: "/settings",
        title: "Настройки",
        icon: "Settings",
      },
    },
  },
  // docs: {
  //   path: '/docs',
  //   title: 'Документация',
  //   sub: {
  //     guide
  //   }
  // },
  contacts: {
    path: "",
    title: "Контакты",
    sub: {
      wa: {
        title: "WhatsApp",
        path: "https://wa.me?phone=77003131919",
        icon: <Image src={"/images/whatsapp.png"} alt="whatsapp" width={16} height={16} />,
      },
      telegram: {
        title: "Telegram",
        path: "https://t.me/alekse31419",
        icon: <Image src={"/images/telegram.png"} alt="telegram" width={16} height={16} />,
      },
      telegramChannel: {
        title: "Telegram",
        path: "https://t.me/sellproKZ",
        icon: <Image src={"/images/telegram.png"} alt="telegram" width={16} height={16} />,
      },
      youtube: {
        title: "YouTube",
        path: "https://www.youtube.com/@alexey-sellpro",
        icon: <Image src={"/images/youtube.png"} alt="youtube" width={16} height={16} />,
      },
    },
  },
});

export default endpoints;
